import { Injectable } from '@angular/core';
import { ConsumeCredencialesService } from '../generico/servicio/consume-credenciales.service';
import { MensajeService } from '../generico/servicio/mensaje.service';
import { Aplicacion } from '../_models/aplicacion';
import { SpinnerService } from 'src/app/spinner.service';
import { promise } from 'protractor';

/* interface Aplica {
  id_aplicacion: number;
  txt_description: string;
  txt_clave: string;
  ind_update: number;
  ind_estado: number;
} */

@Injectable({
  providedIn: 'root'
})



export class AplicacionesService {
  
  aplica: Aplicacion;
  public list_app : any = [];
  private estados_app = {'Activo': 1 , 'Inactivo' : 0}
  public dialog_ref : any;

  constructor( 
    private cred_serv: ConsumeCredencialesService,
    private msjserv : MensajeService,
    private spin : SpinnerService,
    ) { }
    
  /**
   * Funcion que se encarga de crear la aplicaciones.
   * @param data_form data del formulacion de creacion de aplicaciones
   */
  public crearAplicacion(data_form: any){
    let recurso = 'gestionarApp';
    data_form['ind_update'] = 0;

    this.cred_serv.post(recurso, data_form)
                  .subscribe((data: any=[])=>{
                    
                    this.spin.spin$.next(false );
                    let tipo_msg = this.msjserv.TIPO_ERROR

                    if(data.code == 0){

                      this.aplica = new Aplicacion();
                      this.aplica.txt_descripcion = data_form.txt_descripcion;
                      this.aplica.txt_clave = data_form.txt_clave;
                      this.aplica.id_aplicacion = data.data.id_aplicacion;
                      this.aplica.num_sesiones = data_form.num_sesiones;   
                      tipo_msg = this.msjserv.TIPO_OK                   
                      
                    }
                    
                    this.msjserv.ver_mensaje(data.msg, '', tipo_msg);
                  })

  }

  /**
   * obtiene el objeto aplicacion que se esta modificando en este momento.
   */
  public get_aplicacion(){
    return this.aplica;
  }

  /**
   * Consulta todas la aplicacion registradas en la base de datos
   */
  public async consultar_aplicaciones(){

    const promise = this.cred_serv.get('gestionarApp').toPromise();

    await promise.then((data:any)=>{
          this.spin.spin$.next(false );
          let tipo_msg = this.msjserv.TIPO_ERROR

          if(data.code == 0){
            this.list_app = data.data;
          }else{
            this.msjserv.ver_mensaje(data.msg, '', tipo_msg);
          }
                    
        });
  }

  public async consultar_aplicacion(id_aplicacion : number){
    this.aplica = new Aplicacion();
    const promesa = this.cred_serv.get('gestionarApp/'+id_aplicacion).toPromise();

    await promesa.then((data : any )=>{
      this.spin.spin$.next(false);
      if(data.code ==0){
        let json_app = data.data[0];
        
        this.aplica.id_aplicacion = json_app.id;
        this.aplica.txt_descripcion = json_app.nombre;
        this.aplica.ind_estado = this.estados_app[json_app.estado];
        this.aplica.num_sesiones = json_app.num_sesiones

      }else{
        this.msjserv.ver_mensaje(data.msg, '', this.msjserv.TIPO_ERROR);
      }
    });
  }


  public actualizar_aplicacion(data : any){

    this.cred_serv.post('gestionarApp', data)
                  .subscribe(
                    (data : any)  =>{
                      this.spin.spin$.next(false);
                      let tipo_mensaje = this.msjserv.TIPO_OK;
                      if(data.code > 0){
                        tipo_mensaje = this.msjserv.TIPO_ERROR;
                      }

                      this.msjserv.ver_mensaje(data.msg, '', tipo_mensaje);
                    }
                  );
  }

  public set_aplicacion(app : Aplicacion){
    this.aplica = app;
  }
}
